import SpecialSection from '../pages/SpecialSection';
import AboutPage from '../pages/About';
import Visinories from '../pages/Visionaries';
import InfoCards from '../pages/InfoCards';
import BihaniSection from '../pages/BihaniSection';
import sampleVideo from "../assets/web sd.mp4";
import OurSchoolPage from '../pages/OurSchool';
import '../styles/HomePage.css';

export default function HomePage() {
 
  return (
    <div className="homepage">
       <div className="videomaindv">
        <video className="innerVideo" autoPlay loop muted playsInline>
          <source src={sampleVideo} type="video/mp4" />
        </video>
      
    
      </div>
      
      <AboutPage/>
      <OurSchoolPage/>
      <Visinories/>   
      <SpecialSection/> 
      <InfoCards/>
      <BihaniSection/>
    </div>
  );
}